export default __webpack_public_path__ + "static/media/lp-2-rMAX.d89155d1.avif";